// services/analyticsService.js - Analytics API Client

const API_URL = process.env.REACT_APP_API_URL || 'https://jsa.arborascent.com';

class AnalyticsService {
  /**
   * Fetch overview statistics
   */
  async getOverview() {
    const response = await fetch(`${API_URL}/api/analytics/overview`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch overview');
    }

    return response.json();
  }

  /**
   * Fetch hazard analytics
   */
  async getHazards(options = {}) {
    const params = new URLSearchParams();
    if (options.startDate) params.append('startDate', options.startDate);
    if (options.endDate) params.append('endDate', options.endDate);
    if (options.limit) params.append('limit', options.limit);

    const response = await fetch(`${API_URL}/api/analytics/hazards?${params}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch hazard analytics');
    }

    return response.json();
  }

  /**
   * Fetch difficulty metrics
   */
  async getMetrics(options = {}) {
    const params = new URLSearchParams();
    if (options.startDate) params.append('startDate', options.startDate);
    if (options.endDate) params.append('endDate', options.endDate);

    const response = await fetch(`${API_URL}/api/analytics/metrics?${params}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch metrics');
    }

    return response.json();
  }

  /**
   * Fetch trend data
   */
  async getTrends(metric = 'submissions', period = 'daily', options = {}) {
    const params = new URLSearchParams({ metric, period });
    if (options.startDate) params.append('startDate', options.startDate);
    if (options.endDate) params.append('endDate', options.endDate);
    if (options.limit) params.append('limit', options.limit);

    const response = await fetch(`${API_URL}/api/analytics/trends?${params}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch trends');
    }

    return response.json();
  }

  /**
   * Fetch weather trends
   */
  async getWeatherTrends(options = {}) {
    const params = new URLSearchParams();
    if (options.startDate) params.append('startDate', options.startDate);
    if (options.endDate) params.append('endDate', options.endDate);

    const response = await fetch(`${API_URL}/api/analytics/weather?${params}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch weather trends');
    }

    return response.json();
  }

  /**
   * Fetch equipment usage
   */
  async getEquipmentUsage(options = {}) {
    const params = new URLSearchParams();
    if (options.startDate) params.append('startDate', options.startDate);
    if (options.endDate) params.append('endDate', options.endDate);

    const response = await fetch(`${API_URL}/api/analytics/equipment?${params}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch equipment usage');
    }

    return response.json();
  }

  /**
   * Fetch recent submissions
   */
  async getRecentSubmissions(limit = 10) {
    const response = await fetch(`${API_URL}/api/analytics/recent?limit=${limit}`, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch recent submissions');
    }

    return response.json();
  }
}

export default new AnalyticsService();
